// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projects-list .row{padding:0 20px}.project-card{padding:8px;display:inline-block}.project-card .bp4-card{padding-left:0;padding-right:0}.project-card .row+.row{margin-top:1rem}.project-card .project-stats{font-size:10pt}", ""]);
// Exports
module.exports = exports;
